export class Save {
  save = [];
  NATIONALITIES=[]
  completed = false;
  constructor() {
    this.save = this._initSave();
  }

  private _initSave() {
    return [
      {
        key: "FirstName",
        label: "First Name",
        order: 1,
        required: true,
        controlType: "textbox",
        type: "text",
        value: ""
      },
      {
        key: "LastName",
        label: "Last Name",
        order: 2,
        required: true,
        controlType: "textbox",
        type: "text",
        value: ""
      },
      {
        key: "phone",
        label: "Phone",
        order: 3,
        required: true,
        controlType: "textbox",
        type: "text",
        value: ""
      },
      {
        key: "Postcode",
        label: "My Postal Code",
        order: 4,
        required: true,
        controlType: "textbox",
        type: "text",
        value: ""
      },
      {
        key: "NumberOfRooms",
        label: "My House",
        order: 5,
        required: true,
        controlType: "textbox",
        type: "text",
        value: ""
      },
      {
        key: "Nric",
        label: "National Registration Identity Card",
        order: 6,
        required: false,
        controlType: "textbox",
        type: "text",
        value: ""
      },
      {
        key: "CitizenType",
        label: "Opportunity",
        order: 7,
        required: true,
        controlType: "radio",
        type: "radio",
        value: ""
      },
     {
        key: "Nationality",
        label: "Nationality",
        order: 8,
        required: false,
        controlType: "textbox",
        type: "text",
        value: ""
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/save.ts